import styled from "styled-components";

import { StyledEditModalContent } from "@pages/Patients/Laboratory/components/EditModal/EditModal.styled";

import { rem } from "@styles/Utilities.styled";


export const StyledEditConsultationServiceModalContent = styled(StyledEditModalContent)`
  .form {
    margin-top: 1.5rem;
    padding-bottom: 1.5rem;
    
    .form-field {
      margin-bottom: 1rem;
    }

    .form-actions {
      display: flex;
      justify-content: flex-end;
      padding-top: 1.5rem;
      gap: 0.75rem;
    }
  }

  /* Override modal body styles for simpler form layout */
  .mantine-Modal-body {
    padding-bottom: 2rem;
  }

  /* Form field styling */
  .mantine-TextInput-root,
  .mantine-NumberInput-root {
    .mantine-TextInput-label,
    .mantine-NumberInput-label {
      font-weight: 500;
      font-size: ${rem(14)};
      color: var(--clr-primary-700);
      margin-bottom: 0.5rem;
    }

    .mantine-TextInput-input,
    .mantine-NumberInput-input {
      border: 1px solid var(--clr-gray-200);
      border-radius: var(--border-radius-2);
      padding: 0.75rem 1rem;
      font-size: ${rem(14)};
      transition: border-color 0.2s ease;

      &:focus {
        border-color: var(--clr-primary-400);
        box-shadow: 0 0 0 2px rgba(var(--clr-primary-400-rgb), 0.1);
      }

      &::placeholder {
        color: var(--clr-gray-300);
      }
    }

    .mantine-TextInput-error,
    .mantine-NumberInput-error {
      font-size: ${rem(12)};
      color: var(--clr-rose);
      margin-top: 0.25rem;
    }
  }

  /* Button styling */
  .mantine-Button-root {
    font-weight: 500;
    border-radius: var(--border-radius-2);
    padding: 0.75rem 1.5rem;
    font-size: ${rem(14)};
    transition: all 0.2s ease;

    &[data-variant="filled"] {
      background-color: var(--clr-primary-400);
      border: 1px solid var(--clr-primary-400);

      &:hover {
        background-color: var(--clr-primary-500);
        border-color: var(--clr-primary-500);
      }

      &:disabled {
        background-color: var(--clr-gray-200);
        border-color: var(--clr-gray-200);
        color: var(--clr-gray-400);
      }
    }

    &[data-variant="outline"] {
      background-color: transparent;
      border: 1px solid var(--clr-gray-200);
      color: var(--clr-gray-600);

      &:hover {
        background-color: var(--clr-gray-50);
        border-color: var(--clr-gray-300);
      }
    }
  }
`;
